import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function UserMessage(props) {
  const { text } = props;
  return (
    <div
      className={classNames(
        'chat-message-user-wrapper',
        'flex',
        'flex-justify--end',
      )}
    >
      <div className={classNames('chat-message-user', 'flex-1')}>{text}</div>
    </div>
  );
}

UserMessage.propTypes = {
  text: PropTypes.string.isRequired,
};

export default UserMessage;
